export const QualificationEnum = {

  QualifySpeed:  [
    { key: 1, value: "10GBASE-T"},
    { key: 2, value: "5GBASE-T" },
    { key: 3, value: "2.5GBASE-T" },
    { key: 4, value: "1GBASE-T"},
    { key: 5, value: "100BASE-TX" },
    { key: 6, value: "10BASE-T" },
    { key: 0, value: "Wiremap Only" },
  ],
  
  CableType: [
    { key: 18, value: "4-Pair", nvp: 72 },
    { key: 19, value: "2-Pair (12-36)", nvp: 72 },
    { key: 20, value: "2-Pair (12-78)", nvp: 72 },
    { key: 21, value: "2-Pair (45-36)", nvp: 65 },
    { key: 22, value: "1-Pair (45)", nvp: 65 },
  ],

  CableTypeMbps: [
    { key: 18, value: "4-Pair", nvp: 72 },
    { key: 19, value: "2-Pair (12-36)", nvp: 72 },
  ],
  
  DispPref: [
    { key: 0, value: "Standard" },
    { key: 1, value: "568A" },
    { key: 2, value: "568B" },
    { key: 3, value: "USOC" },
    { key: 4, value: "TERA" }
  ]
};

  